let navigator = null;

export const setNavigator = (navigate) => {
  navigator = navigate;
};

export const navigateTo = (to, options) => {
  if (navigator) {
    navigator(to, options);
    return;
  }
  if (typeof window === 'undefined') return;
  if (options?.replace) {
    window.location.replace(to);
  } else {
    window.location.assign(to);
  }
};
